import {
  AccessControl,
  COLOR_MAP,
  EventEmitter,
  Splitter,
  getTranslatedText,
  useIntl,
  useUserMSPCheckHook,
  withErrorBoundary
} from '@nile/components';
import { SVGIcon } from '@superops/super-icons';
import { Button } from '@superops/ui-design-system';
import { isEmpty } from 'lodash';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const ActionToolbarContainer = styled.div`
  width: 95%;
  padding: 16px 0;
  // max-width: 720px;
  max-width: calc(100% - 60px);
  border-radius: 30px;
  background: #ffffff;
  margin: 14px auto;
  border: 1px solid #ececec;
  justify-content: space-evenly;
  .Superops-Button__Text {
    margin-left: 10px !important;
  }
  .ml-3 {
    margin-left: 3px;
  }
`;

const HelpIconWrapper = styled.div`
  margin: 0 16px;
`;

function ActionToolbar(props) {
  const {
    onClick,
    ticket,
    emailSignature,
    createNewSideConversation,
    isDisabled,
    isNotesDisabled,
    isConversationDisabled
  } = props;
  const isMSP = useUserMSPCheckHook();
  const intl = useIntl();

  return (
    <ActionToolbarContainer>
      <div className="fx jspeven" id="actionToolbarHolder">
        {createNewSideConversation && (
          <AccessControl
            roleToCheck="tickets.edit"
            render={
              <>
                <Button
                  plain
                  disabled={props?.isSideConversationDisabled}
                  loading={props?.isSideConversationLoading}
                  onClick={() => {
                    EventEmitter.dispatch('openTicket.side.conversation');
                  }}
                  icon={<SVGIcon color={COLOR_MAP.blue} name="Helpcenter" />}
                >
                  <FormattedMessage id="app.sideConversation.create.new" />
                </Button>
              </>
            }
          />
        )}
        <AccessControl
          roleToCheck="ticketingAddNotes.allow"
          render={
            <>
              <div className="ml-12">
                <Button
                  plain
                  onClick={onClick.bind(this, 'note')}
                  icon={<SVGIcon name="Notes" color={COLOR_MAP.blue} />}
                  disabled={isDisabled || isNotesDisabled}
                >
                  <FormattedMessage id="workItem.details.add.note" />
                </Button>
              </div>
              <Splitter className="ml-12" color={COLOR_MAP.grey} />
            </>
          }
        />
        <div id="conversationReplyBtn" className="fx center ml-12">
          <Button
            plain
            onClick={onClick.bind(this, 'conversation')}
            icon={<SVGIcon name="Reply" color={COLOR_MAP.blue} />}
            customClassName="replyBtn"
            loading={props?.conversationLoading}
            disabled={
              isEmpty(ticket.requester) || isDisabled || isConversationDisabled
            }
          >
            {isMSP ? (
              <>
                <FormattedMessage id="ticket.details.updates.reply.to" />
                <span className="ml-3">
                  {ticket?.requester?.firstName
                    ? `${ticket?.requester?.firstName || ''} ${ticket?.requester
                        ?.lastName || ''}`
                    : ticket?.requester?.name
                    ? `${ticket?.requester?.name || ''}`
                    : ticket?.requester?.email}
                </span>
              </>
            ) : (
              <>
                <FormattedMessage id="common.conversation.reply" />{' '}
              </>
            )}
          </Button>
          {isEmpty(ticket.requester) && (
            <HelpIconWrapper
              title={getTranslatedText(
                intl,
                'ticket.details.updates.noRequesterMessage'
              )}
            >
              <SVGIcon name="HelpIcon" color="var(--sops-black-to-black)" />
            </HelpIconWrapper>
          )}
        </div>
      </div>
    </ActionToolbarContainer>
  );
}

export default withErrorBoundary(ActionToolbar);
